import { Project } from '@/interfaces/project.interface';
import { ApiQueryParams, apiRequest } from '../Api';

export interface CreateProjectResponse {
  success: boolean;
  message: string;
  data: { id: string };
  execution_time: number;
  cached: boolean;
  timestamp: string;
}

export type CreateProjectRequest = Omit<
  Project,
  'id' | 'created_at' | 'updated_at'
> & {
  id?: string;
};

export const createProject = (
  params: ApiQueryParams,
  data: CreateProjectRequest
) =>
  apiRequest<CreateProjectRequest, CreateProjectResponse>({
    url: '/entities/create',
    scope: 'project',
    method: 'POST',
    params,
    data: { data },
  });
